"use client";

export default function ZaloButton() {

    const redirectToZalo = () => {
        window.location.href = "https://zalo.me/conruabien";
    };

    return (
        <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer", marginBottom: 20 }}
            onClick={redirectToZalo}
        >
            <span>Nhấn hoặc Quét Mã Zalo QR</span>
        </div>
    );
}